.app {
  width: 90%;
  max-width: 1280px;
  margin: 0px auto;
  padding: 0 16px 16px;
}

.toolbar {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.button {
  padding: 6px 12px;
  font-size: 16px;
  color: #fff;
  background-color: #0d6efd;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.button:hover {
  background-color: #0b5ed7;
}
